<!-- 底部bar -->
<template>
  <div class="common-tips" v-if="resourceList.length > 0">
    <p class="os-font-18-500">温馨提示</p>
    <ul class="tips-content">
      <li v-for="(item, index) in resourceList" :key="index">
        <p class="os-font-14-400">
          <img v-if="item.imageUrl" :src="item.imageUrl" alt="icon" />
          <span class="os-font-14-500">{{ item.title || `还未配置标题哦` }}</span>
        </p>
        <div class="os-font-12-400" v-html="richText(item.content) || `还未配置内容哦`"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import api from '@/views/repair/introduction/api'
import { mapActions } from 'vuex'

export default {
  name: 'commonTips',
  data() {
    return {
      resourceList: []
    }
  },
  props: {
    positionKey: {
      type: String,
      default: ''
    }
  },
  created() {
    this.positionKey && this.getResource()
  },
  methods: {
    getResource() {
      api
        .getResource({
          positionKey: this.positionKey
        })
        .then(res => {
          if (res.code === 0) {
            this.resourceList = res.data || []
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    richText(content) {
      // 删除所有富文本标签的 style 属性
      if (content) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(content, 'text/html')
        const elements = doc.querySelectorAll('[style]')
        elements.forEach(el => {
          el.removeAttribute('style')
        })
        return doc.body.innerHTML
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
